export type VoidStatus = "vigentes" | "anulados" | "todos";

const LABELS: Record<VoidStatus, string> = {
  vigentes: "Vigentes",
  anulados: "Anulados",
  todos: "Todos",
};

/** Which vouchers a list shows (plan 024): the ones that count, the voided ones, or all. */
export function VoidFilter({
  value,
  onChange,
}: {
  value: VoidStatus;
  onChange: (value: VoidStatus) => void;
}) {
  return (
    <div className="inline-flex rounded-md border border-brand-line text-xs" role="group">
      {(Object.keys(LABELS) as VoidStatus[]).map((status) => (
        <button
          key={status}
          type="button"
          aria-pressed={value === status}
          onClick={() => onChange(status)}
          className={`px-2.5 py-1 first:rounded-l-md last:rounded-r-md ${
            value === status
              ? "bg-brand-primary text-white"
              : "text-brand-muted hover:text-brand-text"
          }`}
        >
          {LABELS[status]}
        </button>
      ))}
    </div>
  );
}
